var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.manageType == "add" ? "新增商品" : "修改商品",
            visible: _vm.dialogVisible,
            width: "60%",
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "section",
            { staticClass: "lists" },
            [
              _c(
                "el-form",
                {
                  ref: "ruleForm",
                  attrs: {
                    model: _vm.ruleForm,
                    rules: _vm.rules,
                    "label-position": "left",
                    "label-width": "110px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称", prop: "name" } },
                    [
                      _c("el-input", {
                        staticClass: "width-400",
                        attrs: {
                          placeholder: "如：手链",
                          clearable: "",
                          maxlength: "20",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "name", $$v)
                          },
                          expression: "ruleForm.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品id", prop: "goods_id" } },
                    [
                      _c("el-input", {
                        staticClass: "width-400",
                        attrs: {
                          placeholder: "请输入商品id",
                          clearable: "",
                          maxlength: "15",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.goods_id,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "goods_id", $$v)
                          },
                          expression: "ruleForm.goods_id",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "正式链接", prop: "link" } },
                    [
                      _c("el-input", {
                        staticClass: "width-400",
                        attrs: {
                          placeholder: "请输入商品正式链接",
                          clearable: "",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.link,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "link", $$v)
                          },
                          expression: "ruleForm.link",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "测试链接", prop: "sandbox_link" } },
                    [
                      _c("el-input", {
                        staticClass: "width-400",
                        attrs: {
                          placeholder: "请输入商品测试链接",
                          clearable: "",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.sandbox_link,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "sandbox_link", $$v)
                          },
                          expression: "ruleForm.sandbox_link",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "商品描述", prop: "desc" } },
                    [
                      _c("el-input", {
                        staticClass: "width-400",
                        attrs: {
                          placeholder: "请输入商品描述",
                          clearable: "",
                          maxlength: "50",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.ruleForm.desc,
                          callback: function ($$v) {
                            _vm.$set(_vm.ruleForm, "desc", $$v)
                          },
                          expression: "ruleForm.desc",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "status" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.ruleForm.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "status", $$v)
                            },
                            expression: "ruleForm.status",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("可用"),
                          ]),
                          _vm._v(" "),
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("禁用"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("ImageUpload", {
                    ref: "imageUpload",
                    attrs: {
                      groupFlag: false,
                      ruleForm: _vm.imageUploadData,
                      required: false,
                      labelTitle: "商品图片",
                      labelWidth: "110px",
                    },
                    on: {
                      "update:ruleForm": function ($event) {
                        _vm.imageUploadData = $event
                      },
                      "update:rule-form": function ($event) {
                        _vm.imageUploadData = $event
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "标签" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "选择标签",
                          },
                          model: {
                            value: _vm.ruleForm.tag,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm, "tag", $$v)
                            },
                            expression: "ruleForm.tag",
                          },
                        },
                        _vm._l(_vm.tags, function (v, k) {
                          return _c("el-option", {
                            key: k,
                            attrs: { label: v.name, value: v.val },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.onCancel } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.submitForm("ruleForm")
                    },
                  },
                },
                [_vm._v("确定并同步")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }